const state = {
  globalModal: {
    open: false,
    content: "",
    icon: "",
    positiveOptions: {
      name: "",
      img: "/img/btn/btn_blue_134x50_fill.svg",
      disabled: false,
      disableImg: "/img/btn/btn_gray_134x50_fill.svg",
      prependIcon: "",
      width: "134px",
      height: "50px",
      fontColor: "#ffffff",
      title: "",
    },
    negativeOptions: {
      name: "",
      img: "/img/btn/btn_gray_134x50.svg",
      disabled: false,
      disableImg: "/img/btn/btn_gray_134x50_fill.svg",
      prependIcon: "",
      width: "134px",
      height: "50px",
      fontColor: "#999999",
    },
    // positive, negative 이벤트 시, 실행할 함수
    positiveFn: null,
    negativeFn: null,
    closeFn: null,
  },
  modalStack: [],

  // c-simple-modal
  simpleModal: {
    open: false,
    content: "",
    title: "",
    date: "",
    icon: "",
    width: "650px",
    height: "",
    type: "plane",
    iconShow: false,
    lottieShow: false,
    btnShow: true,
    negativeBtnOptions: {
      show: true,
      text: "취소",
      width: "94px",
    },
    positiveBtnOptions: {
      show: true,
      text: "확인",
      width: "200px",
    },
    submitFn: null,
    cancelFn: null,
  },

  toast: {
    show: false,
    iconUrl: "",
    text: "",
    time: 3000,
  },

  logoutState: false,

  priceModal: {
    open: false,
    workType: "",
    state: "",
    check: false,
    closeFn: null,
  },
};

const mutations = {
  openGlobalModal: (state, data) => {
    state.globalModal.open = true;
    state.globalModal.content = data.content;
    state.globalModal.icon = data.icon;
    state.globalModal.positiveOptions = data.positiveOptions;
    state.globalModal.negativeOptions = data.negativeOptions;
    state.globalModal.positiveFn = data.positiveFn;
    state.globalModal.negativeFn = data.negativeFn;
    state.globalModal.closeFn = data.closeFn;
    state.globalModal.width = data.width;
  },
  closeGlobalModal: (state) => {
    state.globalModal.open = false;
  },

  addModalStack: (state, id) => {
    state.modalStack.push(id);
  },
  clearModalStack: (state) => {
    state.modalStack = [];
  },
  removeModalStack: (state, id) => {
    state.modalStack = state.modalStack.filter((x) => x !== id);
  },

  openSimpleModal: (state, data) => {
    state.simpleModal.open = true;
    state.simpleModal.content = data.content;
    state.simpleModal.icon = data.icon;
    state.simpleModal.type = data.type;
    state.simpleModal.iconShow = data.iconShow;
    state.simpleModal.lottieShow = data.lottieShow;
    state.simpleModal.btnShow = data.btnShow;
    state.simpleModal.title = data.title;
    state.simpleModal.date = data.date;
    state.simpleModal.positiveBtnOptions = data.positiveBtnOptions;
    state.simpleModal.negativeBtnOptions = data.negativeBtnOptions;
    state.simpleModal.submitFn = data.submitFn;
    state.simpleModal.cancelFn = data.cancelFn;
    state.simpleModal.height = data.height;
  },
  closeSimpleModal: (state) => {
    state.simpleModal = {
      open: false,
      content: "",
      icon: "",
      width: "650px",
      height: "",
      title: "",
      date: "",
      type: "plane",
      iconShow: false,
      lottieShow: false,
      btnShow: true,
      negativeBtnOptions: {
        show: true,
        text: "취소",
        width: "94px",
      },
      positiveBtnOptions: {
        show: true,
        text: "확인",
        width: "200px",
      },
      submitFn: null,
      cancelFn: null,
    };
  },
  openToast: (state, data) => {
    state.toast.show = true;
    state.toast.iconUrl = data.iconUrl;
    state.toast.text = data.text;
    state.toast.time = data.time;
    state.logoutState = false;
  },
  setLogoutState(state, payload) {
    state.logoutState = payload;
  },
  openPriceModal: (state, data) => {
    state.priceModal.open = true;
    state.priceModal.workType = data.workType;
    state.priceModal.check = data.check === undefined ? false : true;
    state.priceModal.closeFn = data.closeFn;
  },
  closePriceModal: (state) => {
    state.priceModal.open = false;
  },
  clearPriceModal: (state) => {
    state.priceModal.workType = "";
    state.priceModal.state = "";
    state.priceModal.check = false;
    state.priceModal.closeFn = null;
  },
  setPriceModal: (state, data) => {
    state.priceModal.workType = data.workType;
    state.priceModal.state = data.submitState;
  },
  setPriceChange: (state, data) => {
    state.priceModal.check = data.check;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
